import React from 'react'
import { FilterGroup } from '@superhi/design'
import { Props as FiltersProps } from '@superhi/design/src/components/misc/FilterGroup/FilterGroup'
import { OptionValue as SelectOptionValue } from '@superhi/design/src/components/forms/inputs/SelectInput/SelectInput'
import { useRouter } from 'next/router'

import { removeUndefined } from '../../../utils'

export type Props<
  F extends { [K in keyof F]: SelectOptionValue },
  S extends { [K in keyof S]: SelectOptionValue },
> = Pick<FiltersProps<F, S>, 'name' | 'filters' | 'numResults' | 'isLoading'> & {
  query: any
}

function Filters<
  F extends { [K in keyof F]: SelectOptionValue },
  S extends { [K in keyof S]: SelectOptionValue },
>({ name, numResults = 0, filters, query, isLoading }: Props<F, S>) {
  const router = useRouter()

  const handleReset = () => {
    router.replace(router.pathname, undefined, {
      shallow: true,
      scroll: false,
    })
  }

  const handleChange = (newQuery: any) => {
    router.replace(
      {
        query: removeUndefined(newQuery) as any,
      },
      undefined,
      {
        shallow: true,
        scroll: false,
      },
    )
  }

  return (
    <FilterGroup<F, S>
      name={name}
      numResults={numResults}
      filters={filters}
      values={query}
      onChange={handleChange}
      onReset={handleReset}
      isLoading={isLoading}
    />
  )
}

export default Filters
